import { render, staticRenderFns } from "./NewQuestion.vue?vue&type=template&id=42b87b9c&"
import script from "./NewQuestion.vue?vue&type=script&lang=ts&"
export * from "./NewQuestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports